module.exports = __webpack_public_path__ + "img/bg_icon_3.8e7b66e2.svg";